import { isKakaoInAppBrowser } from '@app/libs/browserUserAgent';
import isiOS from '@app/libs/isiOS';

export default function closeKakaoInAppBrowser() {
  if (!isKakaoInAppBrowser()) {
    return;
  }

  // 참고: https://hajoung56.tistory.com/73
  if (isiOS) {
    window.location.href = 'kakaoweb://closeBrowser';
  } else {
    // 안드로이드
    window.location.href = 'kakaotalk://inappbrowser/close';
  }
}
